import { createAction } from 'redux-actions'

export const setCliniciansList = createAction('SET_CLINICIANS_LIST')
export const setCliniciansLoader = createAction('SET_CLINICIANS_LOADER')

export const setCliniciansModalLoader = createAction(
  'SET_CLINICIANS_MODAL_LOADER'
)
export const setClinicianUserRoles = createAction('SET_CLINICIAN_USER_ROLES')
